import surfAirImg from 'assets/images/amenitiesAndAttractions/surfAir.jpg'
import surfAirImgLarge from 'assets/images/amenitiesAndAttractions/surfAirLarge.jpg'
import surfAirImgMobile from 'assets/images/amenitiesAndAttractions/surfAirMobile.jpg'
import { SURF_AIR_PRICE } from 'constants/prices'
import Attraction from 'components/shared/Attraction'
import { useIntl } from 'react-intl'
import { useState } from 'react'
import SymulatorModal from './SymulatorModal'
import moment from 'moment'

const AvailableOnSite = () => {
    const { formatMessage } = useIntl()

    const [isSymulatorModalOpen, setIsSymulatorModalOpen] = useState(false)

    const isSurfAirInMaintenance = moment().isSameOrBefore(
        '2024-12-23 23:59:59'
    )

    const handleToggleSymulatorModal = () => {
        setIsSymulatorModalOpen(!isSymulatorModalOpen)
    }

    return (
        <>
            <Attraction
                isAvailableOnline={false}
                title="Surf Air"
                price={SURF_AIR_PRICE}
                isPriceFrom={true}
                pricePer="person"
                details={[
                    formatMessage({
                        id: 'upsells.surfair.abstract',
                        defaultMessage:
                            'Poczuj się jak prawdziwy surfer na symulatorze sztucznej fali w centrum Polski!',
                    }),
                ]}
                images={[
                    surfAirImgMobile,
                    isSurfAirInMaintenance ? surfAirImgLarge : surfAirImg,
                ]}
                handleModalOpening={handleToggleSymulatorModal}
                alert={
                    isSurfAirInMaintenance
                        ? formatMessage({
                              id: 'upsells.surfair.alert',
                              defaultMessage:
                                  'Atrakcja będzie nieczynna do 23 grudnia.',
                          })
                        : undefined
                }
                id="surf-box"
            />
            <SymulatorModal
                isOpened={isSymulatorModalOpen}
                closeModal={handleToggleSymulatorModal}
            />
        </>
    )
}

export default AvailableOnSite
